<div *ngIf="dateValue" class="grid-date">
    <mat-icon class="mat-icon" color="primary">today</mat-icon>
    <span class="info-date ">{{ dateValue }}</span>
  </div>
  